import { Factory } from "@/data/dao/Factory";
import { SystemDao } from "@/data/dao/service/SystemDao";
import type { IApiVersion } from "@/data/model/System";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { ApiVersionForm } from "@/portal/forms/ApiVersionForm";

export class ApiVersionController extends BaseTabbedController<IApiVersion> {
    private versionForm: ApiVersionForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<SystemDao>(SystemDao).apiVersionDataSource);

        this.versionForm = new ApiVersionForm(this.formContentByTabName("versionedit"));
        this.registerModelForm(this.versionForm);
    }

    protected onModelLoaded(m?: IApiVersion) {
        this.versionForm.setData(m);
    }
}
